import { queryKeys } from '@api/queryKeys';
import { HttpError } from '@api/types';
import { Survey } from '@models/survey/survey';
import { useQuery } from '@tanstack/react-query';
import { fetchSurvey } from './feedbackSurvey';

export const useSurvey = () => {
  return useQuery<Survey, HttpError | Error>([queryKeys.survey], fetchSurvey);
};
